import React, { useEffect, useMemo, useState } from "react";
import {
    usePlansQuery,
} from "services/webServer";
import { MEMBERSHIP_INTERVAL, MembershipProductType } from "consts/membership";
import { handleCheckIsFreeMembership } from "../utils/handleCheckIsFreeMembership";
import { CONSTANTS } from "consts";
import moment from "moment";

const OLD_BILLING_CYCLE = [
    {
        key: "2-years",
        interval: MEMBERSHIP_INTERVAL.YEARLY,
        intervalCount: 2,
        label: "2 YEARS",
        description: "Billed every two years",
        price: "$24",
        unit: "month",
        special: "SAVE 4 MONTHS",
    },
    {
        key: "annual",
        interval: MEMBERSHIP_INTERVAL.YEARLY,
        intervalCount: 1,
        label: "ANNUAL",
        description: "Billed annually",
        price: "$24",
        unit: "month",
        special: "SAVE 2 MONTHS",
    },
    {
        key: "monthly",
        interval: MEMBERSHIP_INTERVAL.MONTHLY,
        intervalCount: 1,
        label: "MONTHLY",
        description: "Billed monthly",
        price: "$29",
        unit: "month",
    },
];

const BILLING_CYCLE_20_YEAR_WARRANTY = [
    {
        key: "2-years",
        interval: MEMBERSHIP_INTERVAL.YEARLY,
        intervalCount: 2,
        label: "2 YEARS",
        description: "Billed every two years",
        price: "$29",
        unit: "month",
        special: "SAVE 4 MONTHS",
        warranty: "20-Year Warranty",
    },
    {
        key: "annual",
        interval: MEMBERSHIP_INTERVAL.YEARLY,
        intervalCount: 1,
        label: "ANNUAL",
        description: "Billed annually",
        price: "$29",
        unit: "month",
        special: "SAVE 2 MONTHS",
        warranty: "20-Year Warranty",
    },
    {
        key: "monthly",
        interval: MEMBERSHIP_INTERVAL.MONTHLY,
        intervalCount: 1,
        label: "MONTHLY",
        description: "Billed monthly",
        price: "$34",
        unit: "month",
        warranty: "20-Year Warranty",
    },
];

export const MEMBERSHIP_CREATED_AT_2025 = "2025";


export function useUpgradeMembershipPlan({
    gameMembershipDetail,
    webMembershipDetail,
}: any) {
    let BILLING_CYCLE = OLD_BILLING_CYCLE;
    // const { data: planData } = usePlansQuery();
    const isFreeMembership = handleCheckIsFreeMembership(gameMembershipDetail.planId);

    const isNewMbsPackage2025 = useMemo(() => {
        if(typeof webMembershipDetail === "undefined") return false;
        return moment(webMembershipDetail?.plan?.createdAt as string).format("YYYY") === MEMBERSHIP_CREATED_AT_2025;
    }, [webMembershipDetail])

    const isInactiveStatus = useMemo(() => {
        if(typeof webMembershipDetail === "undefined") return false;
        return webMembershipDetail?.state === "inactive";
    }, [webMembershipDetail])

    const isNewPackageWithoutGo = useMemo(() => {
        if(typeof webMembershipDetail === "undefined") return false;
        const isGo = webMembershipDetail?.plan?.appIds?.includes(CONSTANTS.APP.AVIRON_GO);
        return isNewMbsPackage2025 && Boolean(!isGo);
    }, [webMembershipDetail, isNewMbsPackage2025]);

    const availableBillingCycles = useMemo(() => {
        if (isNewMbsPackage2025) {
            BILLING_CYCLE = BILLING_CYCLE_20_YEAR_WARRANTY
        } else {
            BILLING_CYCLE = OLD_BILLING_CYCLE;
        }
        const isTwoYear = webMembershipDetail?.plan?.intervalCount === 2;
        const isGoModel =
            webMembershipDetail?.plan?.appIds?.length > 0
                ? webMembershipDetail?.plan?.appIds?.includes(
                    CONSTANTS.APP.AVIRON_GO
                )
                : false;
        const isYearly =
            webMembershipDetail?.plan?.interval === MEMBERSHIP_INTERVAL.YEARLY;
        const isCADCurrency = webMembershipDetail?.plan?.currency === "cad";

        if (isFreeMembership) return BILLING_CYCLE;

        if (isTwoYear) {
            if(isNewMbsPackage2025 && isInactiveStatus) return BILLING_CYCLE;
            return BILLING_CYCLE.filter((cycle) => cycle.key === "2-years");
        }
        if (isGoModel) {
            if (isYearly) {
                if(isNewMbsPackage2025 && isInactiveStatus) return BILLING_CYCLE.filter((cycle) => cycle.key === "monthly");
                return []
            }
            // Go Monthly
            return BILLING_CYCLE.filter((cycle) => cycle.key === "annual");
        }
        if (isYearly) {
            return BILLING_CYCLE.filter((cycle) => {
                if (isCADCurrency && !isNewMbsPackage2025) return cycle.key === "annual";
                return isNewMbsPackage2025 && isInactiveStatus ?  true : cycle.key !== "monthly"
            });
        }

        return BILLING_CYCLE.filter((cycle) => {
            if (isCADCurrency && !isNewMbsPackage2025) return cycle.key !== "2-years";
            return cycle
        });
    }, [isFreeMembership, webMembershipDetail, isNewMbsPackage2025, isInactiveStatus]);

    const isTwoYearPackage = useMemo(() => {
        return webMembershipDetail?.plan?.intervalCount === 2;
    }, [webMembershipDetail]);

    // const plans = planData?.plans?.nodes || [];

    // const currentPlan = useMemo(() => {
    //     return plans.find(
    //         (plan) =>
    //             plan.id ===
    //             Number(
    //                 isFreeMembership
    //                     ? webMembershipDetail.remark?.upcomingPlanId
    //                     : webMembershipDetail.planId
    //             )
    //     );
    // }, [plans, webMembershipDetail, isFreeMembership]);

    // useEffect(() => {
    //     if (!currentPlan) return;

    //     if (isNewMbsPackage2025) {
    //         if (isInactiveStatus) {
    //             BILLING_CYCLE = swapItem(BILLING_CYCLE, 0, 1);
    //         } else {
    //             BILLING_CYCLE = BILLING_CYCLE_20_YEAR_WARRANTY;
    //         }
    //     } else {
    //         BILLING_CYCLE = OLD_BILLING_CYCLE;
    //     }

    // }, [currentPlan, isNewMbsPackage2025, isInactiveStatus]);

    return {
        availableBillingCycles,
        isFreeMembership,
        isNewMbsPackage2025,
        isNewPackageWithoutGo,
        isTwoYearPackage
    };
}
